import PaginatedBlogPostsList from './paginated-blog-posts-list.js';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedBlogPostsList {}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
